<script>
    export let fullPage = false
</script>


<div class="loader-wrapper" style:height={fullPage ? 'calc(100vh - 16px)' : 'auto'}>
    <span class="loader"></span>
</div>

<style lang="scss">
    
    .loader-wrapper {

        display: flex;
        align-items: center;
        justify-content: center;
    }

    .loader {
        display: block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #fff;
        box-shadow: 32px 0 #fff, -32px 0 #fff;
        position: relative;
        animation: flash 0.5s ease-out infinite alternate;
    }

    @keyframes flash {
        0% {
            background-color: #FFF2;
            box-shadow: 18px 0 #FFF2, -18px 0 antiquewhite;
        }
        50% {
            background-color: antiquewhite;
            box-shadow: 18px 0 #FFF2, -18px 0 #FFF2;
        }
        100% {
            background-color: #FFF2;
            box-shadow: 18px 0 antiquewhite, -18px 0 #FFF2;
        }
    }
    

</style>